import {PRODUCTION} from 'env';
import {handleError} from './error';

export function registerServiceWorker(): void {
  if (PRODUCTION && 'serviceWorker' in window.navigator) {
    window.navigator.serviceWorker.register('serviceWorker.js').catch(handleError);
  }
}
